import { ParseSpec } from 'prosemirror-markdown';
import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class Paragraph extends BaseExtension {
  protected _schema: NodeSpec = {
    content: 'inline*',
    group: 'block',
    parseDOM: [
      {
        tag: 'p',
        getAttrs: (element) => {
          // Do not pasrse as paragraph if there's no text content inside element,
          // fixes images inside p tag issue.
          if ((element as HTMLElement).getElementsByTagName('img')[0]) {
            return false;
          }

          return null;
        },
      },
    ],
    toDOM: (node) => [
      'p',
      { class: 'body-long-01 text-text-paragraph mt-16', id: node.attrs.id },
      0,
    ],
  };

  get schema(): NodeSpec {
    return this._schema;
  }

  get name(): string {
    return NODE_NAME;
  }

  parseMarkdown(): void | ParseSpec {
    return {
      block: NODE_NAME,
    };
  }

  plugins = plugins;
}
